import { render, staticRenderFns } from "./GroupPayment.vue?vue&type=template&id=f2e1a21c&"
import script from "./GroupPayment.vue?vue&type=script&lang=js&"
export * from "./GroupPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2e1a21c')) {
      api.createRecord('f2e1a21c', component.options)
    } else {
      api.reload('f2e1a21c', component.options)
    }
    module.hot.accept("./GroupPayment.vue?vue&type=template&id=f2e1a21c&", function () {
      api.rerender('f2e1a21c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/GroupPayment.vue"
export default component.exports